module.exports = __webpack_public_path__ + "img/icon_e41.eee27014.png";